/**Les differentes valeurs poss*/ /// </summary>
export enum DefaultDateTimeValue {
  Today = 'Today',
  Yesterday = 'Yesterday',
  Tomorrow = 'Tomorrow',
  FirstWeekday = 'FirstWeekday',
  FirstMonthday = 'FirstMonthday',
  Undefined = 'Undefined',
}
